import { DSCircularIndeterminateIndicator } from '@elliemae/ds-circular-progress-indicator';
import Grid from '@elliemae/ds-grid';
import { styled } from '@elliemae/ds-system';
import React from 'react';
import { DSLeftNavigationName, LEFT_NAVIGATION_SLOTS } from '../../constants/index.js';
import LeftNavigationContext from '../../LeftNavigationContext.js';

const StyledLoaderWrapper = styled(Grid, { name: DSLeftNavigationName, slot: LEFT_NAVIGATION_SLOTS.LOADER_WRAPPER })`
  height: 100%;
  place-items: center;
  z-index: 0;
  background-color: white;
`;

export const LeftNavLoading: React.ComponentType<{ expanded: boolean }> = ({ expanded }) => {
  const { leftNavProps } = React.useContext(LeftNavigationContext);
  const getOwnerProps = React.useCallback(() => leftNavProps, [leftNavProps]);
  const getOwnerPropsArguments = React.useCallback(() => ({}), []);

  return (
    <StyledLoaderWrapper
      role="menuitem"
      aria-label="Loading..."
      getOwnerProps={getOwnerProps}
      getOwnerPropsArguments={getOwnerPropsArguments}
    >
      <DSCircularIndeterminateIndicator
        size={expanded ? 'l' : 's'}
        text="Loading..."
        showText={expanded}
        withTooltip={!expanded}
      />
    </StyledLoaderWrapper>
  );
};
